<template>
    <a @click="downloadAsset" v-html="text" />
</template>

<script>
import { downloadAssetCTF } from '../../../plugins/contentful'
export default {
  name: 'CtfRichTextAssetLink',
  props: {
    sysId: {
      type: String,
      required: true
    },
    text: {
      type: String,
      required: true
    }
  },
  methods: {
    async downloadAsset () {
      const asset = await downloadAssetCTF(this.sysId)
      fetch(asset.fields.file.url, {
        headers: new Headers({
          Origin: location.origin
        }),
        mode: 'cors'
      })
        .then((response) => response.blob())
        .then((blob) => {
          let blobUrl = ''

          if (window.navigator && window.navigator.msSaveOrOpenBlob) {
            blobUrl = window.navigator.msSaveOrOpenBlob(blob, asset.fields.file.fileName)
          } else {
            blobUrl = window.URL.createObjectURL(blob)
          }

          const a = document.createElement('a')
          a.download = asset.fields.title
          a.href = blobUrl
          // For Firefox https://stackoverflow.com/a/32226068
          document.body.appendChild(a)
          a.click()
          a.remove()
        })
        .catch((e) =>
          window.open(
            this.assetToDownload.fields.file.url,
            'Download'
          )
        )
    }
  }
}
</script>
